export default "__VITE_ASSET__Bgb6358Z__"